type Props = {
  className?: string
  width?: number
  height?: number
  color?: string
}

export const DoubleSquareIcon = ({ className, width = 16, height = 16, color }: Props) => {
  return (
    <span className={className}>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 16 16" fill="none">
        <rect x="8" y="0" width="8" height="8" fill={color ?? 'url(#paint0_linear_double_sq_0)'} />
        <rect x="0" y="8" width="8" height="8" fill={color ?? 'url(#paint1_linear_double_sq_1)'} />
        <defs>
          <linearGradient id="paint0_linear_double_sq_0" x1="4" y1="0" x2="4" y2="15" gradientUnits="userSpaceOnUse">
            <stop stopColor="#B7ECDA" />
            <stop offset="1" stopColor="#40AD87" />
          </linearGradient>
          <linearGradient id="paint1_linear_double_sq_1" x1="4" y1="0" x2="4" y2="15" gradientUnits="userSpaceOnUse">
            <stop stopColor="#B7ECDA" />
            <stop offset="1" stopColor="#40AD87" />
          </linearGradient>
        </defs>
      </svg>
    </span>
  )
}
